import { ChangeDetectorRef, Component } from "@angular/core";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";
import { EditTiposreservaComponent } from "./edit-tiposreserva/edit-tiposreserva.component";

@Component({
  selector: "app-tiposreserva",
  templateUrl: "./tiposreserva.component.html",
  styleUrls: ["./tiposreserva.component.scss"],
})
export class TiposreservaComponent extends SuperClassComponent {
  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef
  ) {
    super(panelService, cdRef);
  }

  openPanel() {
    this.customanpanel = EditTiposreservaComponent;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}
